import axios from 'axios';
import { EventTypes } from 'redux-segment';
import { browserHistory } from 'react-router';

const logoutAsync = () => async dispatch => {
  try {
    await dispatch({
      type: 'LOGOUT',
      // @ts-expect-error "meta does not exist in type AxiosRequestConfig"
      payload: axios({
        url: '/session',
        method: 'DELETE',
        responseType: 'json',
        timeout: 20000,
        meta: {
          analytics: {
            eventType: EventTypes.reset,
          },
        },
      }),
    });

    localStorage.removeItem('lastVisitedVenue');
    browserHistory.push('/session');
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  } catch (ex) {
    window.location.assign('/session');
  }
};
export { logoutAsync };
